var SCM = SCM || {};

SCM.SplitScreenLeftPane = (function (ns, elementManager, splitScreenHelper, figuresAndTablesHelper, citationModalHelper) {

    return {
        registerLeftPaneClickAndResizeEvents: registerLeftPaneClickAndResizeEvents
    };


    function doKeywordsSearch(keyword) {
        // make sure keyword is wrapped in quotes
        if (!keyword) {
            return;
        }

        if (!keyword.startsWith('"')) {
            keyword = '"' + keyword;
        }

        if (!keyword.endsWith('"')) {
            keyword = keyword + '"';
        }

        var searchUrl = 'search-results?page=1&qb={"Keywords1":' +
            encodeURIComponent(keyword) +
            '}&SearchSourceType=1';

        var siteUrlElement = document.getElementById('hfSiteURL');

        if (siteUrlElement) {
            searchUrl = '//' + siteUrlElement.value + '/' + searchUrl;
        } else {
            return;
        }

        window.location.href = searchUrl;
    }

    function registerLeftPaneClickAndResizeEvents(widgets, ContentFullText, ContentTopInfo, SolrResourceMetadata, ChapterVersionInformation) {
        var $contentFullText = $(ContentFullText);
        var $contentTopInfo = $(ContentTopInfo);
        var $chapterVersionInformation = $(ChapterVersionInformation);

        // Jumplinks for References and Figures&Tables
        $contentFullText.on('click', '.xref-page', function (e) {
            e.stopPropagation();
            var id = this.dataset.open;
            splitScreenHelper.scrollToRefInSplitView(id, widgets.ReferencesTab);
        });
        $contentFullText.on('click', '.xref-bibr', function (e) {
            e.stopPropagation();
            if (!this.dataset.open) {
                return;
            }

            var id = this.dataset.open.split(' ')[0];
            splitScreenHelper.scrollToRefInSplitView(id, widgets.ReferencesTab);

        });
        $contentFullText.on('click', '.xref-fig', function (e) {
            e.stopPropagation();
            var id = this.dataset.open;
            if (!id) {
                id = this.dataset.modalSourceId;
            }
            figuresAndTablesHelper.scrollInFiguresAndTablesSplitView(id, widgets.FiguresAndTablesTab);
        });
        $contentFullText.on('click', '.xref-default', function (e) {
            e.stopPropagation();
            var id = this.dataset.open;
            if (!id) {
                id = this.dataset.modalSourceId;
            }
            splitScreenHelper.scrollToRefInSplitView(id, widgets.ReferencesTab);
            figuresAndTablesHelper.scrollInFiguresAndTablesSplitView(id, widgets.FiguresAndTablesTab);
        });

        // Jumplinks for Notes
        $contentTopInfo.on('click', '.js-related-object[object-type="end-note"], .js-xref-fn', function (e) {
            e.stopPropagation();
            splitScreenHelper.scrollToNoteInSplitView($(this), widgets.NotesTab);
        });
        $contentFullText.on('click', '.js-related-object[object-type="end-note"], .js-xref-fn', function (e) {
            e.stopPropagation();
            splitScreenHelper.scrollToNoteInSplitView($(this), widgets.NotesTab);
        });
        $contentFullText.on('click', '.js-citation-links', function (e) {
            e.stopPropagation();
            open($(this), widgets.NotesTab);
        });

        // Other xref jumplinks
        $contentFullText.on('click', '.js-xref-sec', function (e) {
            e.stopPropagation();
            splitScreenHelper.findXref(this, ContentFullText);
        });

        // Appendixes
        $contentFullText.on('click', '.js-jumplink', function (e) {
            e.stopPropagation();
            var id = this.attributes['href'].textContent.substring(1);
            var appendixes = ContentFullText.querySelectorAll('.appendix-title[data-legacy-id]');
            for (var i = 0; i < appendixes.length; i++) {
                if (appendixes[i].attributes['data-legacy-id'].textContent === id) {
                    widgets.Content.scrollTop = appendixes[i].offsetTop;
                    return;
                }
            }
        });     

        // Keywords search
        $contentFullText.on('click', '.kwd-part', function (e) {
            e.stopPropagation();
            doKeywordsSearch($(this).data('keyword'));
        });

        $(window).resize(function() {
            if ($('.al-author-info-wrap.open:visible').length && $('.content-panel:visible').length) {
                var $authorCard = $('.al-author-info-wrap.open');
                shiftSVAuthorsCards($authorCard);
            }
        });

        citationModalHelper.registerCitationModalEvents('sv-getCitation');
        registerPubHistoryClickEvent(ContentTopInfo);
        var authorFlyouts = getAuthorFlyouts(ContentTopInfo, ContentFullText, SolrResourceMetadata);
        registerAuthorFlyoutClickEvent(authorFlyouts);
        registerAuthorShowMoreClickEvent(ContentTopInfo);
        registerVersionShowMoreClickEvent($chapterVersionInformation);
    }

    function hideAuthorFlyouts() {
        $('.al-author-info-wrap').removeClass('open');
    }

    
    function registerAuthorFlyoutClickEvent(flyouts) {

        for (var j = 0; j < flyouts.length; j++) {
            flyouts[j].addEventListener('click', function (e) {

                if (!e.stopPropagation) window.event.cancelBubble = true;
                e.stopPropagation();

                hideAuthorFlyouts();

                var $targetModal = $(e.target).siblings('.al-author-info-wrap');
                $('.al-author-info-wrap').not($targetModal).removeClass('open');
                $($targetModal).toggleClass('open');
                $($targetModal).attr('tabindex', '-1').focus();

                $(document.body).on('click', function (e) {
                    if (!$(e.target).parents('.al-author-info-wrap').length) {
                        hideAuthorFlyouts();
                    }
                });

                shiftSVAuthorsCards($targetModal);
            });
        }
    }

    function shiftSVAuthorsCards(authorCard) {
        var $contentPanel = $('.content-panel');
        var columnRightEdge = $contentPanel.position().left + $contentPanel.width();
        SCM.SiteJS.shiftOpenAuthorCards(authorCard, columnRightEdge);
    }
    
    function getAuthorFlyouts(ContentTopInfo, ContentFullText, SolrResourceMetadata) {
        var flyouts = elementManager.getElementsByClassList(ContentTopInfo, ['linked-name', 'js-linked-footnotes']);
        // Add secondary contrib flyouts, if any
        if (splitScreenHelper.isArticlePage()) {
            return flyouts.concat(elementManager.getElementsByClass(ContentFullText, 'linked-name'));
        }
        else {
            return flyouts.concat(elementManager.getElementsByClass(SolrResourceMetadata, 'linked-name'));
        }
    }

    function registerAuthorShowMoreClickEvent(ContentTopInfo) {
        var showMore = elementManager.getFirstElementByClassName(ContentTopInfo, 'meta-authors--etal');
        if (showMore) {
            showMore.addEventListener('click', function (e) {
                e.target.attributes['aria-hidden'] = 'true';
                e.target.style.display = 'none';


                var remaining = elementManager.getFirstElementByClassName(ContentTopInfo, 'meta-authors--remaining');
                if (remaining) {
                    remaining.attributes['aria-hidden'] = 'false';
                    remaining.style.display = 'inline';
                }
            });
        }
    }

    function registerVersionShowMoreClickEvent($chapterVersionInformation) {
        $chapterVersionInformation.on('click', '.js-version-info-more-link', function () {
            $(this).closest('.version-info-text').find('.js-version-info').toggleClass('hide');
        });
    }

    function registerPubHistoryClickEvent(ContentTopInfo) {
        var historys = ContentTopInfo.getElementsByClassName('js-article-history');

        for (var i = 0; i < historys.length; i++) {
            historys[i].addEventListener('click', function () {
                var $pubHistoryDetails = $('.js-history-entries-wrap').last();
                $pubHistoryDetails.toggleClass('expanded');
            });
        }
    }

})(SCM.SplitScreenLeftPane = SCM.SplitScreenLeftPane || {}, SCM.ElementManager, SCM.SplitScreenHelper, SCM.SplitScreenFiguresAndTables, SCM.CitationModal);